import { Tooltip } from '@mesa-labs/mesa-ui';
import React from 'react';
import styled from 'styled-components';
import { formatAssignee } from '../../../../utils/vendorActionItems';


const Wrapper = styled.span`
  align-items: center;
  display: inline-flex;
  gap: 4px;
`;

const Avatar = styled.span<{ $unassigned: boolean }>`
  align-items: center;
  background: ${(p) => (p.$unassigned ? 'transparent' : '#E9D7FE')};
  border: ${(p) => (p.$unassigned ? '1px dashed #98A2B3' : 'none')};
  border-radius: 999px;
  color: #53389E;
  display: inline-flex;
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 700;
  height: 18px;
  justify-content: center;
  width: 18px;
`;

// Initial only, with the full name on hover; for rows too dense for the name.
export function AssigneeAvatar({ email }: { email?: string }): React.ReactElement {
  return <Avatar $unassigned={!email} title={formatAssignee(email)}>{email ? email[0].toUpperCase() : ''}</Avatar>;
}

// The avatar with its name (or `label`) in a mesa-ui Tooltip; portaled, so table cells don't clip it.
export function AssigneeAvatarTooltip({ email, label = formatAssignee(email) }: { email?: string; label?: string }): React.ReactElement {
  return (
    <Tooltip
      anchorElement={<Avatar $unassigned={!email}>{email ? email[0].toUpperCase() : ''}</Avatar>}
      text={label}
      direction="up"
      width="max-content"
    />
  );
}

export default function Assignee({ email }: { email?: string }): React.ReactElement {
  return (
    <Wrapper>
      <AssigneeAvatar email={email} />
      {formatAssignee(email)}
    </Wrapper>
  );
}
